import React from 'react'
import { useParams, Link } from 'react-router-dom'
import { Parts } from "../../Parts"
import Header from '../header/Header'
import Footer from '../footer/Footer'
import Price from '../Price'
import PartImage from '../PartImage'
import { BUSINESS } from '../../config/business'
import "./Part.css"

export default function Part() {
    const { id } = useParams()
    const part = Parts.find((p) => p.id === parseInt(id, 10))

    if (!part) {
        return (
            <div>
                <Header />
                <div className="part-detail part-missing">
                    <h1>Product not found</h1>
                    <p>
                        We could not find that product. It may have been removed or
                        the link may be out of date.
                    </p>
                    <Link className="btn btn-success" to="/Part_catalog">
                        Back to all parts &amp; accessories
                    </Link>
                </div>
                <Footer />
            </div>
        )
    }

    const enquiry = encodeURIComponent(
        `Hi, I'm interested in the ${part.Brand} listed at ₹${part.Price} on your website. Is it in stock?`
    )

    return (
        <div>
            <Header />

            <div className="part-detail">
                <nav className="part-crumb">
                    <Link to="/">Home</Link>
                    <span>/</span>
                    <Link to="/Part_catalog">Parts &amp; Accessories</Link>
                    <span>/</span>
                    <span className="part-crumb-current">{part.Category}</span>
                </nav>

                <div className="part-grid">
                    <div className="part-media">
                        <PartImage src={part.image} alt={part.Brand} />
                    </div>

                    <div className="part-info">
                        <span className="part-category">{part.Category}</span>
                        <h1>{part.Brand}</h1>

                        <Price value={part.Price} />

                        <p className="part-lead">{part.Features}</p>
                        <p className="part-suitability">
                            <strong>Best for:</strong> {part.Suitablility}
                        </p>

                        {part.Specs && (
                            <table className="part-specs">
                                <tbody>
                                    {part.Specs.map(([k, v]) => (
                                        <tr key={k}>
                                            <th scope="row">{k}</th>
                                            <td>{v}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}

                        <div className="part-actions">
                            <a
                                className="btn btn-success"
                                href={`https://wa.me/${BUSINESS.whatsapp}?text=${enquiry}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Enquire on WhatsApp
                            </a>
                            <a
                                className="btn btn-light border"
                                href={`tel:+${BUSINESS.phoneRaw}`}
                            >
                                Call {BUSINESS.phone}
                            </a>
                        </div>

                        <p className="part-note">
                            Available at our Khagaul showroom and for delivery in{' '}
                            {BUSINESS.serviceArea}. Electrical components cannot be
                            exchanged once opened or fitted — see our{' '}
                            <Link to="/warranty-returns">Warranty &amp; Returns Policy</Link>.
                        </p>
                    </div>
                </div>

                <Link className="part-back" to="/Part_catalog">
                    ← Back to all parts &amp; accessories
                </Link>
            </div>

            <Footer />
        </div>
    )
}
